import { render, staticRenderFns } from "./DeviceProjects.vue?vue&type=template&id=654a62c9"
import script from "./DeviceProjects.vue?vue&type=script&lang=js"
export * from "./DeviceProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports